import { useEffect } from 'react'
import useAuth from 'hooks/useAuth'

function Logout() {
  const {
    handlers: { endSession: logout },
  } = useAuth()

  useEffect(() => logout(), [logout])

  return null
}

export default Logout
